const DiscoverNFTInDetails = ({data}) => {

  const {
    popularOfTheWeek__titleHighlight,
    popularOfTheWeek__title,
    nftImgWrapperImg,
    nft_name,
    nft_nameImg,
    nft_desc,
    detailsBlock,
    PriceItem,
    details_icon,
    details_infoTitle,
    details_infoHighlight
  } = data

  return (
    <section className="popularOfTheWeek">
      <h2 className="popularOfTheWeek__title">
        <span className="highlight">{popularOfTheWeek__titleHighlight} </span> {popularOfTheWeek__title}
      </h2>
      <div className="row">
        <div className="col-lg-4 offset-lg-1 col-md-6">
          <div className="popular__card">
            <div className="nft-img-wrapper">
              <img loading="lazy" data-src={nftImgWrapperImg} alt="astronauta 1 NFT" />
            </div>
          </div>
        </div>
        <div className="col-lg-5 col-md-6 mt-s">
          <div className="popular__card">
            <div className="card__header">
              <h4 className="nft_name mt-3">{nft_name}</h4>
              <img loading="lazy" data-src={nft_nameImg} alt="link astronauta 1" className="card__link" />
            </div>
            <p className="nft_desc">{nft_desc}</p>
            <div className="row mt-3">
              {detailsBlock && detailsBlock.map((item , key) => (
                <div className="col-12 col-md-6" key={key}> 
                  <div className="details-block">
                    <div className="details_icon">
                      <img loading="lazy" data-src={item.img} alt="note" width={30} />
                    </div>
                    <div className="details_info">
                      <h4>{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
              <div className="col-12 col-md-12">
                <h4 className="nft_name">{PriceItem}</h4>
                <div className="details-block special">
                  <div className="details_icon">
                    <img loading="lazy" data-src={details_icon} alt="note" width={30} />
                  </div>
                  <div className="details_info">
                    <h4>{details_infoTitle}</h4>
                    <p className="highlight">{details_infoHighlight}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiscoverNFTInDetails;